<script>
export default {
    computed: {
        effectedWarningEnabled: function() {
            if(this.$store.page.changeWarningEnabled && this.module.hasEffects) {
                return true
            }

            return false                
        }
    },
    methods: {
        goingToChangeValue() {
            if(this.effectedWarningEnabled) {
                $(':focus').blur()
                this.$event.$emit('call-change-warning-modal')
                
                return false
            }

            return true
        }
    },
}
</script>